import { render, staticRenderFns } from "./GoodsAnchor.vue?vue&type=template&id=9f8a2c84&scoped=true"
import script from "./GoodsAnchor.vue?vue&type=script&lang=js"
export * from "./GoodsAnchor.vue?vue&type=script&lang=js"
import style0 from "./GoodsAnchor.vue?vue&type=style&index=0&id=9f8a2c84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8a2c84",
  null
  
)

export default component.exports